(() => {
  const concierge = document.querySelector('[data-ag-line-concierge]');

  if (!concierge) return;

  const expanded = concierge.querySelector('.ag-line-concierge__expanded');
  const expandedLink = concierge.querySelector('.ag-line-concierge__link');
  const closeButton = concierge.querySelector('[data-ag-line-concierge-close]');
  const launcher = concierge.querySelector('[data-ag-line-concierge-launcher]');
  const storageKey = concierge.dataset.storageKey || 'ag-line-concierge-dismissed';
  const states = ['expanded', 'minimized'];

  const readState = () => {
    try {
      const storedState = window.sessionStorage.getItem(storageKey);
      return states.includes(storedState) ? storedState : null;
    } catch (error) {
      return null;
    }
  };

  const writeState = (state) => {
    try {
      window.sessionStorage.setItem(storageKey, state);
      return true;
    } catch (error) {
      return false;
    }
  };

  const applyState = (state) => {
    const isExpanded = state === 'expanded';

    concierge.dataset.state = state;
    expanded?.setAttribute('aria-hidden', String(!isExpanded));
    launcher?.setAttribute('aria-hidden', String(isExpanded));
    launcher?.setAttribute('aria-expanded', String(isExpanded));
  };

  const setState = (state, shouldFocus) => {
    writeState(state);
    applyState(state);

    if (shouldFocus) {
      const focusTarget = state === 'minimized' ? launcher : expandedLink;
      focusTarget?.focus({ preventScroll: true });
    }
  };

  window.setTimeout(() => {
    if (!concierge.isConnected) return;

    concierge.hidden = false;
    concierge.setAttribute('aria-hidden', 'false');
    applyState(readState() || 'expanded');
    window.requestAnimationFrame(() => {
      concierge.dataset.state = concierge.dataset.state || 'expanded';
    });
  }, 1200);

  closeButton?.addEventListener('click', () => {
    setState('minimized', true);
  });

  launcher?.addEventListener('click', () => {
    setState('expanded', true);
  });
})();
